import React, { useState, useEffect, useRef, useCallback } from "react";
import { Grid, List, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import { Formik, Form, validateYupSchema } from "formik";
import * as Yup from "yup";
import Moment from "moment";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import CreateContact from "../../masters/accounts/CreateContact"
import { DatePickerInput } from 'rc-datepicker';
import 'moment/locale/en-gb.js';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
import { DeviceHubOutlined } from "@material-ui/icons";
// import Loader from "../../biztran_controls/Loader";

Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};


const CreateQuotation = (props) => {
  const classes = useStyles();
  // debugger;
  const [QuotationNo, setQuotationNo] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].QuotationNo === null ? '' : props.QuotationMainData[0].QuotationNo);
  const [Mode, setMode] = useState("");
  const [QuotationDate, setQuotationDate] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].QuotationDate === null ? Moment(new Date()).format("YYYY-MM-DD") : Moment(props.QuotationMainData[0].QuotationDate).format("YYYY-MM-DD"));
  const [CompanyID, setCompanyID] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].CompanyID === null ? '' : props.QuotationMainData[0].CompanyID);
  const [AccountID, setAccountID] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].AccountID === null ? '' : props.QuotationMainData[0].AccountID);
  const [LeadID, setLeadID] = useState("");
  const [Options, setAccountOptions] = useState([]);
  // const [CurrencyID,setCurrencyID] = useState("");
  // const [Leadcmb, setLeadcmb] = useState([]);
  // const [Revise,setRevise] = useState(true);
  const [LeadSourceID, setLeadSourceID] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].LeadSourceID === null ? '' : props.QuotationMainData[0].LeadSourceID);
  // const [BankName,setBankName] = useState("");
  const [ContactID, setContactID] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].ContactID === null ? '' : props.QuotationMainData[0].ContactID);
  const [CompanyName, setCompanyName] = useState("");
  const [QuotationStage, setQuotationStage] = useState(props.QuotationMainData === undefined ? "New" : props.QuotationMainData[0].QuotationStage);
  const [ModeOfTransport, setModeOfTransport] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].ModeOfTransport === null ? '' : props.QuotationMainData[0].ModeOfTransport);
  // const [scheduler, setscheduler] = useState("");
  const { index, style } = props;
  const [ValidUpTo, setValidUpTo] = useState(props.QuotationMainData === undefined ? Moment(new Date().addDays(15)).format("YYYY-MM-DD") : Moment(props.QuotationMainData[0].ValidUpTo).format("YYYY-MM-DD"));
  const [isOpen, setOpen] = useState(false);
  const [Warranty, setWarranty] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].Warranty === null ? '' : props.QuotationMainData[0].Warranty);
  const [QuotationType, setQuotationType] = useState("");
  const [PredictedClosingDate, setPredictedClosingDate] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].PredictedClosingDate === null ? '' : Moment(props.QuotationMainData[0].PredictedClosingDate).format("YYYY-MM-DD"));
  const [EnqRefDate, setEnqRefDate] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].EnqRefDate === null ? '' : Moment(props.QuotationMainData[0].EnqRefDate).format("YYYY-MM-DD"));
  //const [TotalAmount, setTotalAmount] = useState("");
  //const [GstAmount, setGstAmount] = useState("");
  const [Revised, setRevised] = useState("false");
  const [AccountName, setAccountName] = useState(props.QuotationMainData === undefined ? { id: props.AccountID, AccountName: props.AccountName } : { id: props.QuotationMainData[0].AccountID, List: props.QuotationMainData[0].AccountName });
  const [Description, setDescription] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].Description === null ? '' : props.QuotationMainData[0].Description);
  const [HeaderSplNote, setHeaderSplNote] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].HeaderSplNote === null ? '' : props.QuotationMainData[0].HeaderSplNote);
  const [SplNote, setSplNote] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].SplNote === null ? '' : props.QuotationMainData[0].SplNote);
  const [TotalGrossWeight, setTotalGrossWeight] = useState("");
  const [TotalNetWeight, setTotalNetWeight] = useState("");
  const [EnqRef, setEnqRef] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].EnqRef === null ? '' : props.QuotationMainData[0].EnqRef);
  const [responseCust, fetchCustData] = UseFetchData();
  const [BillAddress1, setBillAddress1] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].BillAddress1 === null ? '' : props.QuotationMainData[0].BillAddress1);
  const [BillAddress2, setBillAddress2] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].BillAddress2 === null ? '' : props.QuotationMainData[0].BillAddress2);
  const [BillCity, setBillCity] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].BillCity === null ? '' : props.QuotationMainData[0].BillCity);
  const [PaymentTermsID, setPaymentTermsID] = useState('');
  const [PaymentTerms, setPaymentTerms] = useState(props.QuotationMainData === undefined ? { id: props.PaymentTermsID, List: props.PaymentTerms } : { id: props.QuotationMainData[0].PaymentTermsID, List: props.QuotationMainData[0].PaymentTerms });
  const [Payment, setPayment] = useState(props.QuotationMainData === undefined ? { id: props.PaymentTermsID, List: props.PaymentTerms } : { id: props.QuotationMainData[0].PaymentTermsID, List: props.QuotationMainData[0].PaymentTerms });
  // const [responsePaymentTerms, fetchPaymentTermsData] = UseFetchData();
  const [PaymentTermsOptions, setPaymentTermsOptions] = useState(props.cmbPaymentTermsOptions.length > 0 ? props.cmbPaymentTermsOptions : []);
  const [BillCountryID, setBillCountryID] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].BillCountryID === null ? '' : props.QuotationMainData[0].BillCountryID);
  const [BillStateID, setBillStateID] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].BillStateID === null ? '' : props.QuotationMainData[0].BillStateID);
  const [BillPINCode, setBillPINCode] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].BillPINCode === null ? '' : props.QuotationMainData[0].BillPINCode);
  const [ShipAddress1, setShipAddress1] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].ShipAddress1 === null ? '' : props.QuotationMainData[0].ShipAddress1);
  const [ShipAddress2, setShipAddress2] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].ShipAddress2 === null ? '' : props.QuotationMainData[0].ShipAddress2);
  const [ShipCity, setShipCity] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].ShipCity === null ? '' : props.QuotationMainData[0].ShipCity);
  const [StateData, setStateData] = useState("");
  // const [AccResponse, fetchAcc] = UseFetchData();
  const [ShipCountryID, setShipCountryID] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].ShipCountryID === null ? '' : props.QuotationMainData[0].ShipCountryID);
  const [ShipStateID, setShipStateID] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].ShipStateID === null ? '' : props.QuotationMainData[0].ShipStateID);
  const [ShipPINCode, setShipPINCode] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].ShipPINCode === null ? '' : props.QuotationMainData[0].ShipPINCode);
  const [Accountcmb, setAccountcmb] = useState([]);
  const [Contactcmb, setContactcmb] = useState([]);
  const [BankCmb, setBankCmb] = useState([]);
  const [Companycmb, setCompanycmb] = useState([]);
  const [Currencycmb, setCurrencycmb] = useState([]);
  const [LeadSourcecmb, setLeadSourcecmb] = useState([]);
  const [BillCountrycmb, setBillCountrycmb] = useState([]);
  const [BillStatecmb, setBillStatecmb] = useState([]);
  const [ShipCountrycmb, setShipCountrycmb] = useState([]);
  const [ShipStatecmb, setShipStatecmb] = useState([]);
  const [IncoTerms, setIncoTerms] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].IncoTerms === null ? '' : props.QuotationMainData[0].IncoTerms);
  const [PFCharges, setPFCharges] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].PFCharges === null ? 0 : props.QuotationMainData[0].PFCharges);
  const [PFChargesPer, setPFChargesPer] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].PFChargesPer === null ? 0 : props.QuotationMainData[0].PFChargesPer);
  const [DiscountAmount, setDiscountAmount] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].DiscountAmount === null ? 0 : props.QuotationMainData[0].DiscountAmount);
  const [DiscountPer, setDiscountPer] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].DiscountPer === null ? 0 : props.QuotationMainData[0].DiscountPer);
  const [CFCharges, setCFCharges] = useState('');
  const [OtherCharges1, setOtherCharges1] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].OtherCharges1 === null ? '' : props.QuotationMainData[0].OtherCharges1);
  const [OtherCharges1Amt, setOtherCharges1Amt] = useState(props.QuotationMainData === undefined ? 0 : props.QuotationMainData[0].OtherCharges1Amt);
  const [OtherCharges2, setOtherCharges2] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].OtherCharges2 === null ? '' : props.QuotationMainData[0].OtherCharges2);
  const [OtherCharges2Amt, setOtherCharges2Amt] = useState(props.QuotationMainData === undefined ? 0 : props.QuotationMainData[0].OtherCharges2Amt);
  const [FreightCharges, setFreightCharges] = useState("");
  const [Delivery, setDelivery] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].Delivery === null ? '' : props.QuotationMainData[0].Delivery);
  const [MakeID, setMakeID] = useState(props.QuotationMainData === undefined || props.QuotationMainData[0].MakeID === null ? '' : props.QuotationMainData[0].MakeID);
  const [Origin, setOrigin] = useState("India");
  const [BoxSize, setBoxSize] = useState('');
  const [DisableAddbtn, setDisableAddbtn] = useState(false);
  const [DisablePfCharges, setDisablePfCharges] = useState(false);
  const [DisablePfChargesPer, setDisablePfChargesPer] = useState(false);
  const [DisableDiscountAmount, setDisableDiscountAmount] = useState(false);
  const [DisableDiscountPer, setDisableDiscountPer] = useState(false);
  const [Brandcmb, setBrandcmb] = useState([]);
  const [Paymentcmb, setPaymentcmb] = useState([]);
  const [ACAccount, setACAccount] = useState(props.cmbACAccount.length > 0 ? props.cmbACAccount : []);
  // const [ACContact, setACContact] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  // const [isDoubleChecked,setisDoubleChecked] = useState(false);
  const [Cresponse, CfetchData] = UseFetchData();
  const [ComboDataResponse, fetchComboData] = UseFetchData();
  const [response, fetchData] = UseFetchData();
  const [responseAccDtls, fetchAccDtlsData] = UseFetchData();
  const [responsContactDtls, fetchContactDtlsData] = UseFetchData();
  const [responsPayment, fetchPaymentData] = UseFetchData();
  // const inputEl = useRef(null);
  const { value, onChange, ...rest } = props;
  const [cursor, setCursor] = useState(null);
  const ref = useRef(null);
  const [label, setlabel] = useState(false);
  const [loading, setLoading] = useState(true);
  const [DisablecloseBtn, setDisablecloseBtn] = useState(false);


  const GetAccountData = (AccountID) => {
    // debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("AccountID", AccountID);
    setLoading(true);
    fetchAccDtlsData("Account/GetByID", bodyFormData);
  };

  const GetContactData = (AccountID) => {
    //debugger;
    var bodyFormData = new FormData();
    var acid = "";
    if (AccountID != undefined && AccountID != "") {
      acid = AccountID;
    } else if (AccountName.id != undefined && AccountName.id != "" && AccountName.id != null) {
      acid = AccountName.id
    } else {
      // alert("Please Select account");
      return;
    }
    // if (AccountID == undefined || (AccountName.id != undefined && AccountName.id != "" && AccountName.id != null)) {
    //   bodyFormData.append("AccountID", AccountName.id);
    // }
    // else if (AccountID != "" && ContactID != "") {
    //   bodyFormData.append("AccountID", AccountID);
    // }
    // else if (AccountID != "" && ContactID == "") {
    //   bodyFormData.append("AccountID", AccountID);
    // }
    // else {
    //   bodyFormData.append("AccountID", AccountName.id);
    // }
    bodyFormData.append("AccountID", acid);
    fetchContactDtlsData("Quotation/GetCotactDtlsByAccID", bodyFormData);
  };

  const AddContact = () => {
    // debugger;
    setOpen(true);
    setContactID('');
    // if (ContactID == "") {
    // setAccountName(AccountName);
    // }
    // else {
    //   setAccountName(AccountName);
    // }
    // console.log(AccountName);
    // setAccountID(props.QuotationMainData[0].AccountID);
  }

  const QuotationStageOption = [
    { key: "New", value: "New" },
    { key: "Close", value: "Close" },
    { key: "Expired", value: "Expired" },
    { key: "SalesOrder", value: "SalesOrder" },
  ];

  const schedulerOptions = [
    { key: "3 Days", value: "3 Days" },
    { key: "1 Weak", value: "1 Weak" },
    { key: "3 Weak", value: "3 Weak" },
    { key: "1 Year", value: "1 Year" },
  ];

  const CompanyNameOptions = [
    { key: "POWERMASTER TORQUE SYSTEMS PRIVATE LIMITED", value: "POWERMASTER TORQUE SYSTEMS PRIVATE LIMITED" },
    { key: "POWERMASTER ENGINEERS PRIVATE LIMITED ", value: "POWERMASTER ENGINEERS PRIVATE LIMITED" },
    { key: "POWERMASTER TOOLS PRIVATE LIMITED", value: "POWERMASTER TOOLS PRIVATE LIMITED" },
  ];

  const ModeOfTransportOptions = [
    { key: "By Air", value: "By Air" },
    { key: "By Road", value: "By Road" },
    { key: "By Sea", value: "By Sea" },
    { key: "Courier", value: "Courier" },
    { key: "Customer Hand", value: "Customer Hand" },
  ];

  const WarrantyOptions = [
    { key: "3 Month", value: "3 Month" },
    { key: "6 Month", value: "6 Month" },
    { key: "1 Year", value: "1 Year" },
  ];

  const IncoTermsOptions = [
    { key: "C&F", value: "C&F" },
    { key: "CFR", value: "CFR" },
    { key: "DAP", value: "DAP" },
    { key: "DDU", value: "DDU" },
    { key: "DDP", value: "DDP" },
    { key: "FCA", value: "FCA" },
    { key: "FOB", value: "FOB" },
    { key: "FOR", value: "FOR" },
    { key: "EX-WORKS", value: "EX-WORKS" },
    { key: "EX-WORKS, MUMBAI, INDIA", value: "EX-WORKS, MUMBAI, INDIA" },
    { key: "FOB, MUMBAI, INDIA", value: "FOB, MUMBAI, INDIA" },
  ];

  const IncoTermsData = () => {
    let IncoTerms = IncoTermsOptions.map((data) => (
      <option key={data.key} value={data.value}>
        {data.key}
      </option>
    ));
    return IncoTerms;
  };

  const QuotationStageData = () => {
    let QuotationStage = QuotationStageOption.map((data) => (
      <option key={data.key} value={data.value}>
        {data.key}
      </option>
    ));
    return QuotationStage;
  };

  const ModeOfTransportData = React.useCallback(() => {
    let ModeOfTransport = ModeOfTransportOptions.map((data) => (
      <option key={data.key} value={data.value}>
        {data.key}
      </option>
    ));
    return ModeOfTransport;
  }, []);


  const validationSchema = Yup.object({
    CompanyID: Yup.string().required("Required!"),
    AccountID: Yup.string().required("Required!"),
    EnqRefDate: Yup.string().required("Required!"),
    PredictedClosingDate: Yup.string().required("Required!"),

  });


  useEffect(() => {
    const input = ref.current;
    if (input) input.setSelectionRange(cursor, cursor);
  }, [ref, cursor, value]);


  const handleChange = (e) => {
    // setCursor(e.target.selectionStart);
    onChange && onChange(e);
  };


  const onSubmit = values => {
    //debugger;
    setMode("Insert")
    var UpdatedByID = sessionStorage.UID;
    var GeneratedByID = sessionStorage.UID;
    var bodyFormData = new FormData();
    var QuotationID = "";
    var Revise = Revised;
    var Payterm = null;
    var bodyFormData = new FormData();
    if (props.Mode === "Insert") {
      QuotationID = '';
    }
    else {
      QuotationID = props.QuotationID;
    }
    if (props.Mode === "Insert") {
      QuotationID = '';
    }
    else if (props.QuotationID == undefined) {
      QuotationID = props.QuotationMainData[0].id;
    }
    else {
      QuotationID = props.QuotationID;
    }
    // if (PaymentTermsID !== "") {
    //   PaytermID = PaymentTermsID;
    // }
    if (PaymentTerms !== "") {
      Payterm = PaymentTerms;
    }
    bodyFormData.append("QuotationID", QuotationID);
    if (Revise == "true") {
      bodyFormData.append("Rev", Revise);
    } else {
      const Rev = 0;
      bodyFormData.append("Rev", Rev);
    }
    bodyFormData.append("QuotationNo", values.QuotationNo);
    bodyFormData.append("QuotationDate", values.QuotationDate);
    bodyFormData.append("AccountID", values.AccountID);
    bodyFormData.append("ContactID", values.ContactID);
    bodyFormData.append("LeadSourceID", values.LeadSourceID);
    bodyFormData.append("QuotationType", '');
    bodyFormData.append("QuotationStage", QuotationStage);
    bodyFormData.append("GeneratedByID", GeneratedByID);
    bodyFormData.append("HandledByID", GeneratedByID);
    bodyFormData.append("PredictedClosingDate", values.PredictedClosingDate);
    bodyFormData.append("EnqRefDate", values.EnqRefDate);
    bodyFormData.append("ValidUpTo", values.ValidUpTo);
    bodyFormData.append("CompanyID", values.CompanyID);
    bodyFormData.append("HeaderSplNote", values.HeaderSplNote);
    // bodyFormData.append("Description", values.Description);
    bodyFormData.append("EnqRef", values.EnqRef);
    bodyFormData.append("BillAddress1", values.BillAddress1);

    // setlabel(true);
    bodyFormData.append("BillAddress2", values.BillAddress2);

    // if (values.BillCity !== null && values.BillCity !== "" && value.BillCity == "null") {
    //   var BillAdd = "";
    //   bodyFormData.append("BillCity", BillAdd);
    // }
    // else {
    // setlabel(true);
    bodyFormData.append("BillCity", values.BillCity);
    // }
    bodyFormData.append("BillCountryID", values.BillCountryID);
    if (values.BillStateID !== null && values.BillStateID !== "" && values.BillStateID == "null") {
      var BillAdd = "";
      bodyFormData.append("BillStateID", BillAdd);
    }
    else {
      // setlabel(true);
      bodyFormData.append("BillStateID", values.BillStateID);
    }
    // bodyFormData.append("BillPINCode", values.BillPINCode);
    if (values.BillPINCode == "null") {
      var BillPin = "";
      bodyFormData.append("BillPINCode", BillPin);
    }
    else {
      bodyFormData.append("BillPINCode", values.BillPINCode);
    }
    bodyFormData.append("ShipAddress1", values.ShipAddress1);
    bodyFormData.append("ShipAddress2", values.ShipAddress2);
    bodyFormData.append("ShipCountryID", values.ShipCountryID);
    bodyFormData.append("ShipCity", values.ShipCity);
    bodyFormData.append("ShipCountryID", values.ShipCountryID);
    if (values.ShipStateID == "null") {
      var ShipState = "";
      bodyFormData.append("ShipStateID", ShipState);
    }
    else {
      bodyFormData.append("ShipStateID", values.ShipStateID);
    }
    // bodyFormData.append("ShipPINCode", values.ShipPINCode);
    if (values.ShipPINCode == "null") {
      var ShipPin = "";
      bodyFormData.append("ShipPINCode", ShipPin);
    }
    else {
      bodyFormData.append("ShipPINCode", values.ShipPINCode);
    }
    bodyFormData.append("UpdatedByID", UpdatedByID);
    if (values.IncoTerms == null) {
      var OtherCA = "";
      bodyFormData.append("IncoTerms", OtherCA);
    }
    else {
      bodyFormData.append("IncoTerms", values.IncoTerms);
    }
    if (values.PFCharges == null && values.PFCharges == "") {
      var OtherCA = "";
      bodyFormData.append("PFCharges", OtherCA);
    }
    else {
      bodyFormData.append("PFCharges", values.PFCharges);
    }
    if (values.PFChargesPer == null && values.PFChargesPer == "") {
      var OtherCA = "";
      bodyFormData.append("PFChargesPer", OtherCA);
    }
    else {
      bodyFormData.append("PFChargesPer", values.PFChargesPer);
    }
    if (values.DiscountAmount == null && values.DiscountAmount == "") {
      var OtherCA = "";
      bodyFormData.append("DiscountAmount", OtherCA);
    }
    else {
      bodyFormData.append("DiscountAmount", values.DiscountAmount);
    }
    if (values.DiscountPer == null && values.DiscountPer == "") {
      var OtherCA = "";
      bodyFormData.append("DiscountPer", OtherCA);
    }
    else {
      bodyFormData.append("DiscountPer", values.DiscountPer);
    }
    if (values.OtherCharges2 == null && values.OtherCharges2 == "") {
      var OtherCA = "";
      bodyFormData.append("OtherCharges1", OtherCA);
    }
    else {
      bodyFormData.append("OtherCharges1", values.OtherCharges1);
    }
    if (values.OtherCharges1Amt == null) {
      var OtherCA = "0";
      bodyFormData.append("OtherCharges1Amt", OtherCA);
    }
    else {
      bodyFormData.append("OtherCharges1Amt", values.OtherCharges1Amt);
    }
    if (values.OtherCharges2 == null && values.OtherCharges2 == "") {
      var OtherCA = "";
      bodyFormData.append("OtherCharges2", OtherCA);
    }
    else {
      bodyFormData.append("OtherCharges2", values.OtherCharges2);
    }
    if (values.OtherCharges2Amt == null) {
      var OtherCA = "0";
      bodyFormData.append("OtherCharges2Amt", OtherCA);
    }
    else {
      bodyFormData.append("OtherCharges2Amt", values.OtherCharges2Amt);
    }
    if (values.ModeOfTransport == null && values.ModeOfTransport == "") {
      var MOT = "";
      bodyFormData.append("ModeOfTransport", MOT);
    }
    else {
      bodyFormData.append("ModeOfTransport", values.ModeOfTransport);
    }
    // bodyFormData.append("BrandID", values.BrandID);
    if (values.Warranty == null && values.Warranty == "") {
      var Warrty = "";
      bodyFormData.append("Warranty", Warrty);
    }
    else {
      bodyFormData.append("Warranty", values.Warranty);
    }
    if (values.Origin == null && values.Origin == "") {
      var OR = "";
      bodyFormData.append("Origin", OR);
    }
    else {
      bodyFormData.append("Origin", values.Origin);
    }
    if (values.SplNote == null && values.SplNote == "") {
      var SpN = "";
      bodyFormData.append("SplNote", SpN);
    }
    else {
      bodyFormData.append("SplNote", values.SplNote);
    }
    if (QuotationID != "" && QuotationID != null) {
      var Payterm = PaymentTerms.List;
      if (Payterm == undefined) {
        bodyFormData.append("PaymentTerms", PaymentTerms);
      }
      else if (Payterm != undefined) {
        bodyFormData.append("PaymentTerms", PaymentTerms.List);
      }
    }
    else {
      bodyFormData.append("PaymentTerms", PaymentTerms);
      GetPaymentData();
    }
    if (values.Delivery == null && values.Delivery == "") {
      var Devery = "";
      bodyFormData.append("Delivery", Devery);
    }
    else {
      bodyFormData.append("Delivery", values.Delivery);
    }
    setLoading(true);
    setDisablecloseBtn(true);
    fetchData("Quotation/Save", bodyFormData);
    // values.preventDefault();

  };

  useEffect(() => {
    if (PFCharges > 0) {
      setDisablePfChargesPer(true);
    }
    else if (PFCharges == 0) {
      setDisablePfChargesPer(false);
    }
  }, [PFCharges]);

  useEffect(() => {
    if (PFChargesPer != 0) {
      setDisablePfCharges(true);
    }
    else {
      setDisablePfCharges(false);
    }
  }, [PFChargesPer]);

  useEffect(() => {
    if (DiscountPer > 0) {
      setDisableDiscountAmount(true);
    }
    else {
      setDisableDiscountAmount(false);
    }
  }, [DiscountPer]);

  useEffect(() => {
    if (DiscountAmount > 0) {
      setDisableDiscountPer(true);
    }
    else {
      setDisableDiscountPer(false);
    }
  }, [DiscountAmount]);



  const OnRevise = () => {
    setRevised("true")
  };

  useEffect(() => {
    //debugger;
    if (isChecked) {
      setShipAddress1(BillAddress1);
      setShipAddress2(BillAddress2);
      setShipCountryID(BillCountryID);
      setShipStateID(BillStateID);
      setShipCity(BillCity);
      setShipPINCode(BillPINCode);
    }
    else if (props.QuotationID !== undefined && ShipAddress1 !== "") {
      setShipAddress1(BillAddress1);
      setShipAddress2(BillAddress2);
      setShipCountryID(BillCountryID);
      setShipStateID(BillStateID);
      setShipCity(BillCity);
      setShipPINCode(BillPINCode);
    }
    else if (ShipAddress1 !== "" && props.QuotationMainData[0].id !== undefined) {
      setShipAddress1(BillAddress1);
      setShipAddress2(BillAddress2);
      setShipCountryID(BillCountryID);
      setShipStateID(BillStateID);
      setShipCity(BillCity);
      setShipPINCode(BillPINCode);
    }
    else {
      setShipAddress1("");
      setShipAddress2("");
      setShipCountryID("");
      setShipStateID("");
      setShipCity("");
      setShipPINCode("");
    }

  }, [isChecked]);


  const ContactData = React.useCallback((options) => {
    if (options !== undefined) {
      let Contact = options.map((data) => (
        <option key={data.ContactName} value={data.ContactID}>
          {data.ContactName}
        </option>
      ));
      setContactcmb(Contact);
    }
  }, []);


  const LeadSourceData = React.useCallback((options) => {
    if (options !== undefined) {
      let LeadSource = options.map((data) => (
        <option key={data.LeadSource} value={data.LeadSourceID}>
          {data.LeadSource}
        </option>
      ));
      setLeadSourcecmb(LeadSource);
    }
  }, []);

  const CompanyData = React.useCallback((options) => {
    if (options !== undefined) {
      let Company = options.map((data) => (
        <option key={data.CompanyName} value={data.CompanyID}>
          {data.CompanyName}
        </option>
      ));
      setCompanycmb(Company);
    }
  }, []);


  const CountryData = React.useCallback((options) => {
    if (options !== undefined) {
      let Country = options.map((data) => (
        <option key={data.Country} value={data.CountryID}>
          {data.Country}
        </option>
      ));
      setBillCountrycmb(Country);
      setShipCountrycmb(Country);
    }
  }, []);

  const BillStatecmbData = (CID) => {
    // debugger;
    var id = "";
    if (CID !== "") {
      id = CID;
    } else if (BillCountryID !== "") {
      id = BillCountryID;
    } else {
      id = "";
    }
    let options = ComboDataResponse["State"];
    if (options !== undefined) {
      if (id !== "") {
        let State = options
          .filter((option) => option.CountryID === id)
          .map((data) => (
            <option key={data.StateName} value={data.StateID}>
              {data.StateName}
            </option>
          ));
        setBillStatecmb(State);
      }

      else {
        let State = options.map((data) => (
          <option key={data.StateName} value={data.StateID}>
            {data.StateName}
          </option>
        ));
        setBillStatecmb(State);
      }
    }
  };

  const ShipStatecmbData = (CID) => {
    // debugger;
    var id = "";
    if (CID !== "") {
      id = CID;
    } else if (BillCountryID !== "") {
      id = BillCountryID;
    } else {
      id = "";
    }
    let options = ComboDataResponse["State"];
    if (options !== undefined) {
      if (id !== "") {
        let State = options
          .filter((option) => option.CountryID === id)
          .map((data) => (
            <option key={data.StateName} value={data.StateID}>
              {data.StateName}
            </option>
          ));
        setShipStatecmb(State);
      }
      else {
        let State = options.map((data) => (
          <option key={data.StateName} value={data.StateID}>
            {data.StateName}
          </option>
        ));
        setShipStatecmb(State);
      }
    }
  };


  useEffect(() => {
    // debugger;
    if (ComboDataResponse['LeadSource'] !== undefined && ComboDataResponse['LeadSource'].length > 0) {
      setLoading(false);
      LeadSourceData(ComboDataResponse["LeadSource"]);
    } else {
      LeadSourceData([]);
    }
    if (ComboDataResponse['Country'] !== undefined && ComboDataResponse['Country'].length > 0) {
      setLoading(false);
      CountryData(ComboDataResponse["Country"]);
    } else {
      CountryData([]);
    }
    if (ComboDataResponse['Company'] !== undefined && ComboDataResponse['Country'].length > 0) {
      setLoading(false);
      CompanyData(ComboDataResponse["Company"]);
    } else {
      CompanyData([]);
    }
    if (ComboDataResponse['cmbAccount'] !== undefined && ComboDataResponse['cmbAccount'].length > 0) {
      setACAccount(ComboDataResponse['cmbAccount']);
    } else {
      setACAccount([]);
    }
    if (ComboDataResponse['cmbPaymentTerms'] !== undefined && ComboDataResponse['cmbPaymentTerms'].length > 0) {
      setLoading(false);
      setPaymentTermsOptions(ComboDataResponse['cmbPaymentTerms']);
    } else {
      setPaymentTermsOptions([]);
    }
    if (ComboDataResponse['State'] !== undefined && ComboDataResponse['State'].length > 0) {
      setLoading(false);
      setStateData(ComboDataResponse['State']);
    } else {
      setStateData([]);
    }
    if (props.QuotationID !== "") {
      BillStatecmbData("");
      ShipStatecmbData("");
      console.log(PaymentTerms);
      setMode("Update");

    } else {
      setMode("Insert");
    }

  }, [ComboDataResponse])


  useEffect(() => {
    GetComboData();
    if (AccountName != undefined && AccountName != "") {
      GetContactData('');
    }
  }, []);

  useEffect(() => {
    if (responsContactDtls !== undefined && responsContactDtls.length > 0) {
      // setLoading(true);
      ContactData(responsContactDtls);
      // setAccountName({ id: responsContactDtls[0].AccountID, List: responsContactDtls[0].AccountName });
      // GetContactData(responsContactDtls[0].AccountID === null ? "" : responsContactDtls[0].AccountID);
      // setAccountID(responsContactDtls[0].AccountID === null ? "" : responsContactDtls[0].AccountID);
      // setContactID(responsContactDtls[0].ContactID === null ? "" : responsContactDtls[0].ContactID);

    } else {
      ContactData([]);
    }
  }, [responsContactDtls])



  const GetComboData = async () => {
    setLoading(true);
    await fetchComboData("Quotation/ComboData");
  };

  const onAccountSelectChange = React.useCallback((e, ACData) => {
    // debugger;
    setAccountID(ACData.id);
    setAccountName(ACData);
    GetAccountData(ACData.id);
    GetContactData(ACData.id);
  }, []);

  const onCheckChange = (e) => {
    // debugger;
    setIsChecked(e.target.checked);
    console.log(isChecked);
  };

  const onSelectChange = (e) => {
    // debugger;
    let targetvalue = e.target.value;
    let targetname = e.target.name;
    if (targetvalue !== "") {
      // debugger;

      if (targetname === "AccountID") {
        setAccountID(targetvalue);
        GetAccountData(targetvalue);
        BillStatecmbData(targetvalue);
        // GetContactData(targetvalue);
      } else if (targetname === "LeadID") {
        setLeadID(targetvalue);
      } else if (targetname === "CompanyID") {
        setCompanyID(targetvalue);
      } else if (targetname === "LeadSourceID") {
        setLeadSourceID(targetvalue)
        // } else if (targetname === "CurrencyID") {
        //   setCurrencyID(targetvalue)
      } else if (targetname === "ContactID") {
        setContactID(targetvalue);
      } else if (targetname === "BillCountryID") {
        setBillCountryID(targetvalue);
        BillStatecmbData(targetvalue);
      } else if (targetname === "BillStateID") {
        // setBillCountryID(targetvalue);
        setBillStateID(targetvalue);
      } else if (targetname === "ShipCountryID") {
        setShipCountryID(targetvalue);
        ShipStatecmbData(targetvalue);
      } else if (targetname === "ShipStateID") {
        // setShipCountryID(targetvalue);
        setShipStateID(targetvalue);
      } else if (targetname === "BrandID") {
        setMakeID(targetvalue);
      }
      // } else if (targetname === "PaymentTermsID") {
      //   setPaymentTermsID(targetvalue);
      // }
    } else {
      if (targetname === "AccountID") {
        // debugger;
        setAccountID("");
        GetAccountData("");
        // GetContactData("");
        ContactData([]);
        setBillAddress1('');
        setBillAddress2('');
        setBillCity('');
        setBillCountryID('');
        setBillStateID('');
        setBillPINCode('');
      } else if (targetname === "LeadID") {
        setLeadID("");
      } else if (targetname === "CompanyID") {
        setCompanyID(targetvalue);
      } else if (targetname === "LeadSourceID") {
        setLeadSourceID("");
      } else if (targetname === "ContactID") {
        setContactID("");
      } else if (targetname === "BillCountryID") {
        setBillCountryID("");
        setBillStatecmb([]);
      } else if (targetname === "BillStateID") {
        // setBillStatecmb([]);
        setBillStateID("");
      } else if (targetname === "ShipCountryID") {
        setShipStateID("");
        setShipStateID([]);
      } else if (targetname === "ShipStateID") {
        setShipStateID("");
      } else if (targetname === "BrandID") {
        setMakeID("");
      }
    }
  };

  useEffect(() => {
    //debugger;
    if ((response.Response === true) && (Mode === 'Insert')) {
      setLoading(false);
      alert('Data Saved Succesfully.');
      setRevised("false");
      props.PopulateData();
      setDisablecloseBtn(true);
      props.setOpen(false);


      // window.removeEventListener('load', props.PopulateData());
    }

    // return () => {
    //   window.removeEventListener('load',  props.PopulateData());
    // };
    else if (response.Response === false) {
      setLoading(false);
      alert('Failed.');
      setDisablecloseBtn(false);

    }
  }, [response])


  //  const  shouldComponentUpdate = (nextProps, nextState) => {
  //   debugger;
  //     if (props.response === nextProps.response) {
  //       return false; // don't re-render if myProp and count didn't change
  //     }
  //     return true; // re-render if myProp or count changed
  //   }

  const onPaymentTermsChange = React.useCallback((event, newValue) => {
    // debugger;
    setPaymentTerms(newValue.List);
    setPayment(newValue);
    console.log(newValue);
  }, []);


  const GetPaymentData = (newValue) => {
    // debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("QuotationID", props.QuotationID);
    bodyFormData.append("PaymentTerms", PaymentTerms);
    setLoading(true);
    fetchPaymentData("Quotation/PaymentSubmit", bodyFormData);
  };
  // const onChangeData = (Value, Name) => {
  //   if (Name == "DiscountPer") {
  //     setDiscountPer(Value)
  //     if (Value > 0) {
  //       setDisableDiscountAmount(true);
  //     }
  //     else {
  //       setDisableDiscountAmount(false);
  //     }
  //   }
  //   if (Name == "DiscountAmount") {
  //     setDiscountAmount(e.target.value)
  //     if (e.target.value > 0) {
  //       setDisableDiscountPer(true);
  //     }
  //     else {
  //       setDisableDiscountPer(false);
  //     }
  //   }
  // }

  // useEffect(() => {
  //   //// debugger;
  //   if (responsPayment.Response === true) {
  //     console.log(responsPayment.Message);
  //     alert(responsPayment.Message);
  //   }
  //   else if (responsPayment.Response === false) {
  //     if (responsPayment.Message.includes('Already') === true) {
  //       alert(responsPayment.Message);
  //     }
  //     else {
  //       alert('Failed.');
  //     }
  //   }
  // }, [responsPayment])

  useEffect(() => {
    if (responseAccDtls !== undefined && responseAccDtls.length > 0) {
      setLoading(false);
      setBillAddress1(responseAccDtls[0].BillAddress1 === null ? "" : responseAccDtls[0].BillAddress1);
      setBillAddress2(responseAccDtls[0].BillAddress2 === null ? "" : responseAccDtls[0].BillAddress2);
      setBillCity(responseAccDtls[0].BillCity === null ? "" : responseAccDtls[0].BillCity);
      setBillCountryID(responseAccDtls[0].BillCountryID === null ? "" : responseAccDtls[0].BillCountryID);
      setBillStateID(responseAccDtls[0].BillStateID === null ? "" : responseAccDtls[0].BillStateID);
      setBillPINCode(responseAccDtls[0].BillPINCode === null ? "" : responseAccDtls[0].BillPINCode);
      setShipAddress1(responseAccDtls[0].ShipAddress1 === null ? "" : responseAccDtls[0].ShipAddress1);
      setShipAddress2(responseAccDtls[0].ShipAddress2 === null ? "" : responseAccDtls[0].ShipAddress2);
      setShipCity(responseAccDtls[0].ShipCity === null ? "" : responseAccDtls[0].ShipCity);
      setShipCountryID(responseAccDtls[0].ShipCountryID === null ? "" : responseAccDtls[0].ShipCountryID);
      setShipStateID(responseAccDtls[0].ShipStateID === null ? "" : responseAccDtls[0].ShipStateID);
      setShipPINCode(responseAccDtls[0].ShipPINCode === null ? "" : responseAccDtls[0].ShipPINCode);
    }
  }, [responseAccDtls])


  useEffect(() => {
    if (AccountID == "") {
      setDisableAddbtn(true);
    } else {
      setDisableAddbtn(false);
    }
  }, []);

  let QuotationStagecmb = QuotationStageData();
  let IncoTermscmb = IncoTermsData();



  return <div>

    {/* {
      loading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 10,
        }}>
          <Loader />
        </div>
      )
    } */}
    <Formik initialValues={{
      QuotationNo: QuotationNo, AccountID: AccountID, QuotationDate: QuotationDate, CompanyID: CompanyID, PaymentTermsID: PaymentTermsID,
      LeadSourceID: LeadSourceID, PFCharges: PFCharges, PFChargesPer: PFChargesPer, DiscountAmount: DiscountAmount, DiscountPer: DiscountPer, CFCharges: CFCharges,
      OtherCharges2: OtherCharges2, OtherCharges2Amt: OtherCharges2Amt, OtherCharges1: OtherCharges1, OtherCharges1Amt: OtherCharges1Amt, FreightCharges: FreightCharges,
      ContactID: ContactID, QuotationType: QuotationType, QuotationStage: QuotationStage, ModeOfTransport: ModeOfTransport, ValidUpTo: ValidUpTo,
      PredictedClosingDate: PredictedClosingDate, EnqRefDate: EnqRefDate, EnqRef: EnqRef, AccountName: AccountName, CompanyName: CompanyName,
      Description: Description, HeaderSplNote: HeaderSplNote, BillAddress1: BillAddress1, BillAddress2: BillAddress2, BillCity: BillCity, BillCountryID: BillCountryID, BillStateID: BillStateID,
      BillPINCode: BillPINCode, ShipAddress1: ShipAddress1, ShipAddress2: ShipAddress2, ShipCity: ShipCity, ShipCountryID: ShipCountryID, ShipStateID: ShipStateID, ShipPINCode: ShipPINCode,
      Delivery: Delivery, Payment: Payment, PaymentTerms: PaymentTerms, IncoTerms: IncoTerms, BrandID: MakeID, Origin: Origin, SplNote: SplNote, Warranty: Warranty,
      TotalGrossWeight: TotalGrossWeight, TotalNetWeight: TotalNetWeight, BoxSize: BoxSize,
    }}
      validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize >
      {/* change */}
      {(formik) => {
        return (
          <Form>
            <Typography style={{ marginTop: "-16px", marginBottom: "10px" }} className={classes.headertext} noWrap>
              Quotation Information
            </Typography>
            <Grid spacing={1} container direction="row">
              <Grid item xs={1.5} style={{ marginRight: 14 }} >
                <label
                  htmlFor={"QuotationNo"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Quotation No"}
                </label>
              </Grid>
              <Grid item xs={2}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  name="QuotationNo"
                  disabled={true}
                  onChange={(e) => setQuotationNo(e.target.value)}
                />
              </Grid>
              <Grid item xs={1.5} style={{ marginRight: 10 }}>
                <label
                  htmlFor={"QuotationDate"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                  type="date"
                >
                  {"Quotation Date"}
                </label>
              </Grid>
              <Grid item xs={2}>
                <BiztranControlsFormik
                  control="input"
                  type="date"
                  name="QuotationDate"
                  disabled={true}
                  onChange={(e) => setQuotationDate(e.target.value)}
                />
              </Grid>
              <Grid item xs={1} style={{ marginRight: 2 }}>
                <label
                  htmlFor={"CompanyName"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Company"}
                </label>
              </Grid>
              <Grid item xs={4} >
                <BiztranControlsFormik
                  control="select"
                  name="CompanyID"
                  options={Companycmb}
                  onChange={onSelectChange}
                />
              </Grid>

              <Grid item xs={1.5}>
                <label
                  htmlFor={"QuotationStage"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"QuotationStage"}
                </label>
              </Grid>
              <Grid item xs={2}>
                <BiztranControlsFormik
                  control="select"
                  options={QuotationStagecmb}
                  name="QuotationStage"
                  disabled={true}
                  // value={QuotationStage}
                  onChange={(e) => setQuotationStage(e.target.value)}
                />
              </Grid>
              <Grid item xs={1.5} style={{ marginRight: 24 }}>
                <label
                  htmlFor={"LeadSourceID"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"Lead Source "}
                </label>
              </Grid>
              <Grid item xs={2} >
                <BiztranControlsFormik
                  control="select"
                  name="LeadSourceID"
                  options={LeadSourcecmb}
                  onChange={onSelectChange}
                />
              </Grid>
              <Grid item xs={1} style={{ marginRight: 2 }}>
                <label htmlFor={"AccountID"}
                  style={{
                    display: 'block',
                    width: '100%',
                  }}>
                  {"Account"}
                </label>
              </Grid>
              <Grid item xs={4}>
                <BiztranControls.Autocomplete
                  options={ACAccount}
                  onChange={onAccountSelectChange}
                  value={AccountName}
                  name="AccountID"
                  disabled={props.DisableCustomer}
                />
              </Grid>
              <Grid item xs={1.5} style={{ marginRight: 2 }}>
                <label
                  htmlFor={"ValidUpTo"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"ValidUpTo Date"}
                </label>
              </Grid>
              <Grid item xs={2}>
                <BiztranControlsFormik
                  control="input"
                  type="date"
                  name="ValidUpTo"
                  defaultValue={ValidUpTo}
                  onChange={(e) => setValidUpTo(e.target.value)}
                />
              </Grid>
              <Grid item xs={1.5} >
                <label
                  htmlFor={"PredictedClosingDate"}
                  style={{
                    display: "block",
                    width: "100%",
                  }}
                >
                  {"PreClosing Date"}
                </label>
              </Grid>
              <Grid item xs={2}>
                <BiztranControlsFormik
                  control="input"
                  type="date"
                  name="PredictedClosingDate"
                  onChange={(e) => setPredictedClosingDate(e.target.value)}
                />
              </Grid>
              <Grid item xs={1.5} style={{ marginRight: 12 }}>
                <label
                  htmlFor={"ContactID"}
                  style={{
                    display: "block",
                    width: "100%",
                    justifyContent: 'space-between',
                  }}
                >
                  {"Contact"}
                  <BiztranControls.Button
                    text="Add"
                    style={{ height: "2%", maxwidth: "2", fontSize: 4 }}
                    disabled={DisableAddbtn}
                    onClick={() => {
                      AddContact();
                    }}
                  />
                </label>
              </Grid>
              <Grid item xs={3} >
                <BiztranControlsFormik
                  control="select"
                  name="ContactID"
                  value={ContactID}
                  options={Contactcmb}
                  onChange={onSelectChange}
                />
              </Grid>
              <Grid item xs={1.5} style={{ marginTop: 10, marginRight: 35 }}>
                <label
                  htmlFor={"EnqRefDate"}
                  style={{
                    display: "block",
                    width: "100%",
                    justifyContent: 'space-between',
                    flexDirection: 'row',
                  }}
                >
                  {"Enq. Date"}
                </label>
              </Grid>
              <Grid item xs={2}>
                <BiztranControlsFormik
                  control="input"
                  type="date"
                  name="EnqRefDate"
                  onChange={(e) => setEnqRefDate(e.target.value)}
                />
              </Grid>
              <Grid item xs={1.5} style={{ marginTop: 10, marginRight: 50 }}>
                <label
                  htmlFor={"EnqRef"}
                  style={{
                    display: "block",
                    width: "100%",
                    justifyContent: 'space-between',
                    flexDirection: 'row',
                  }}
                >
                  {"Enq.Ref."}
                </label>
              </Grid>
              <Grid item xs={2}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  name="EnqRef"
                  ref={ref}
                  value={EnqRef}
                  onChange={(e) => {
                    setEnqRef(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={1} style={{ marginTop: 10, pmarginRight: 35 }}>
                <label
                  htmlFor={"HeaderSplNote"}
                  style={{
                    display: "block",
                    width: "100%",

                  }}
                >
                  {"Misc"}
                </label>
              </Grid>
              <Grid item xs={4}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  name="HeaderSplNote"
                  ref={ref}
                  value={HeaderSplNote}
                  onChange={(e) => {
                    setHeaderSplNote(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={12} style={{ marginTop: 3 }}>
                <Typography className={classes.headertext} noWrap>
                  Address Information
                </Typography>
              </Grid>
              <Grid item xs={8} style={{ display: "flex", marginLeft: "50%" }}>
                <label>Shipping Address Same as Billing Address?</label>
                <div style={{ paddingRight: 10 }}>
                  <input
                    type="checkbox"
                    name="chkbox"
                    checked={isChecked}
                    onChange={onCheckChange}
                  ></input>
                </div>
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="textarea"
                  type="text"
                  label="Bill Address1"
                  name="BillAddress1"
                  ref={ref}
                  value={BillAddress1}
                  onChange={(e) => {
                    setBillAddress1(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="textarea"
                  type="text"
                  label="Bill Address2"
                  name="BillAddress2"
                  ref={ref}
                  value={BillAddress2}
                  onChange={(e) => {
                    setBillAddress2(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="textarea"
                  type="text"
                  label="Ship Address1"
                  name="ShipAddress1"
                  ref={ref}
                  value={ShipAddress1}
                  onChange={(e) => {
                    setShipAddress1(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="textarea"
                  type="text"
                  label="Ship Address2"
                  name="ShipAddress2"
                  ref={ref}
                  value={ShipAddress2}
                  onChange={(e) => {
                    setShipAddress2(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="select"
                  label="Bill Country"
                  name="BillCountryID"
                  options={BillCountrycmb}
                  onChange={onSelectChange}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="select"
                  label="Bill State"
                  name="BillStateID"
                  options={BillStatecmb}
                  onChange={onSelectChange}
                />
                {label == true ?
                  <label
                    htmlFor={"Please enter state"}
                    style={{
                      display: "block",
                      width: "100%",
                      color: 'red',
                      marginTop: 15,
                      marginLeft: 10,
                      fontSize: 10,
                    }}
                  >
                    {"Please enter state"}
                  </label>
                  : null
                }
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="select"
                  label="Ship Country"
                  name="ShipCountryID"
                  options={ShipCountrycmb}
                  onChange={onSelectChange}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="select"
                  label="Ship State"
                  name="ShipStateID"
                  options={ShipStatecmb}
                  onChange={onSelectChange}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  label="Bill City"
                  name="BillCity"
                  ref={ref}
                  value={BillCity}
                  onChange={(e) => {
                    setBillCity(e.target.value)
                    handleChange()
                  }
                  }
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="input"
                  type="number"
                  label="Bill PIN Code"
                  name="BillPINCode"
                  ref={ref}
                  value={BillPINCode}
                  onChange={(e) => {
                    setBillPINCode(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  label="Ship City"
                  name="ShipCity"
                  ref={ref}
                  value={ShipCity}
                  onChange={(e) => {
                    setShipCity(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="input"
                  type="number"
                  label="Ship PIN Code"
                  name="ShipPINCode"
                  ref={ref}
                  value={ShipPINCode}
                  onChange={(e) => {
                    setShipPINCode(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={12} >
                <Typography className={classes.headertext} noWrap>
                  Terms & Conditions
                </Typography>
              </Grid>
              <Grid item xs={3}
              >
                <BiztranControls.Autocomplete
                  control="input"
                  type="text"
                  label="Payment Terms"
                  options={PaymentTermsOptions}
                  style={{ marginTop: 5, width: "217px" }}
                  onChange={onPaymentTermsChange}
                  onChangeText={(e) => {
                    setPaymentTerms(e.target.value)
                  }}
                  value={Payment}
                >
                </BiztranControls.Autocomplete>
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  label="Delivery"
                  name="Delivery"
                  ref={ref}
                  value={Delivery}
                  onChange={(e) => {
                    setDelivery(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <label
                  htmlFor={"PFCharges"}
                  style={{
                    display: "block",
                    marginTop: 25,
                    width: "100%",
                  }}
                >
                  {"Packing & Forwarding"}
                </label>
              </Grid>
              <Grid item xs={2} >
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  label="Charges"
                  name="PFCharges"
                  disabled={DisablePfCharges}
                  onChange={(e) => {
                    setPFCharges(e.target.value)
                    // if (e.target.value > 0) {
                    //   setDisablePfChargesPer(true);
                    // }
                    // else {
                    //   setDisablePfChargesPer(false);
                    // }
                  }
                  }
                />
              </Grid>
              <Grid item xs={1}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  label=" % "
                  name="PFChargesPer"
                  disabled={DisablePfChargesPer}
                  onChange={(e) => {
                    setPFChargesPer(e.target.value)
                    // if (e.target.value > 0) {
                    //   setDisablePfCharges(true);
                    // } else {
                    //   setDisablePfCharges(false);
                    // }
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  label="Mode of Shipment"
                  name="ModeOfTransport"
                  ref={ref}
                  value={ModeOfTransport}
                  onChange={(e) => {
                    setModeOfTransport(e.target.value)
                    handleChange()
                  }
                  }
                />
              </Grid>
              {/* <Grid item xs={3}>
                <BiztranControlsFormik
                  control="select"
                  label="ModeOfTransport"
                  name="ModeOfTransport"
                  options={ModeOfTransportcmb}
                  onChange={(e) => setModeOfTransport(e.target.value)}
                />
              </Grid> */}
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="select"
                  label="Inco Terms"
                  options={IncoTermscmb}
                  name="Incoterms"
                  //disabled={true}
                  value={IncoTerms}
                  onChange={(e) => setIncoTerms(e.target.value)}
                />
              </Grid>
              <Grid item xs={3}>
                <label
                  htmlFor={"DiscountAmount"}
                  style={{
                    display: "block",
                    marginTop: 5,
                    width: "100%",
                  }}
                >
                  {"Discount"}
                </label>
              </Grid>
              <Grid item xs={2} >
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  name="DiscountAmount"
                  disabled={DisableDiscountAmount}
                  onChange={(e) => {
                    // onChangeData(e.target.value, "DiscountAmount")
                    setDiscountAmount(e.target.value)

                  }
                  }
                />
              </Grid>
              <Grid item xs={1}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  name="DiscountPer"
                  disabled={DisableDiscountPer}
                  onChange={(e) => {
                    // onChangeData(e.target.value, "DiscountPer")
                    setDiscountPer(e.target.value)
                    // if (e.target.value > 0) {
                    //   setDisableDiscountAmount(true);
                    // }
                    // else {
                    //   setDisableDiscountAmount(false);
                    // }
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  label="Warranty"
                  name="Warranty"
                  ref={ref}
                  value={Warranty}
                  onChange={(e) => {
                    setWarranty(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={3}>
              </Grid>
              <Grid item xs={3} style={{ marginTop: -20 }}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  label="Other-1 "
                  name="OtherCharges1"
                  ref={ref}
                  value={OtherCharges1}
                  onChange={(e) => {
                    setOtherCharges1(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={3} style={{ marginTop: -20 }}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  label="Other-1 value"
                  name="OtherCharges1Amt"
                  onChange={(e) => {
                    setOtherCharges1Amt(e.target.value)
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <BiztranControlsFormik
                  control="textarea"
                  type="text"
                  label="Special Note"
                  name="SplNote"
                  ref={ref}
                  value={SplNote}
                  onChange={(e) => {
                    setSplNote(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={3} style={{ marginTop: -25 }}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  label="Other-2 "
                  name="OtherCharges2"
                  ref={ref}
                  value={OtherCharges2}
                  onChange={(e) => {
                    setOtherCharges2(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={3} style={{ marginTop: -25 }}>
                <BiztranControlsFormik
                  control="input"
                  type="text"
                  label="Other-2 value"
                  name="OtherCharges2Amt"
                  onChange={(e) => {
                    setOtherCharges2Amt(e.target.value)
                    handleChange()
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <div style={{ width: "100%" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignContent: "center",
                    }}
                  >
                    < BiztranControls.Button
                      text="Revise"
                      type="submit"
                      onClick={() => {
                        OnRevise();
                      }}
                      startIcon={<SwapHorizIcon />}
                    />
                    < BiztranControls.Button
                      text="SAVE"
                      type="submit"
                      disabled={DisablecloseBtn}
                      startIcon={<SaveIcon />}
                    />
                    < BiztranControls.Button
                      text="CLOSE"
                      startIcon={<CloseIcon />}
                      onClick={() => {
                        props.setOpen(false);
                      }}
                    />
                    <ModalFrame
                      title="Contact Details"
                      maxWidth="md"
                      isOpen={isOpen}
                      headerAlign="center"
                      setOpen={setOpen}
                    >
                      <CreateContact
                        ContactID={ContactID}
                        AccountID={AccountID}
                        AccountName={AccountName.List}
                        setOpen={setOpen}
                        PopulateData={GetContactData}
                      />
                    </ModalFrame>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Form>
        )
      }}
    </Formik>
  </div>
}

const useStyles = makeStyles((theme) => ({
  headertext: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2rem",
    paddingLeft: "30px",
    fontSize: "1.5rem",
    marginLeft: "-24px",
    marginRight: "-24px",
  },
}));

export default CreateQuotation;
